import { download, generateCsv, mkConfig } from 'export-to-csv';

export const useDownloadCSV = () => {
  const downloadResultsCSV = async (fileName, csvData) => {
    // mkConfig merges your options with the defaults
    // and returns WithDefaults<ConfigOptions>
    const csvConfig = mkConfig({
      useKeysAsHeaders: true,
      filename: fileName,
    });

    // Converts your Array<Object> to a CsvOutput string based on the configs
    const csv = generateCsv(csvConfig)(csvData);
    // downloads the csv file
    download(csvConfig)(csv);
  };

  return { downloadResultsCSV };
};
